import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import * as KJUR from 'jsrsasign';
import { PageService } from '../../services/page.service';
interface SocialCtrlInterface {
  class?: string;
  title?: string;
  description?: string;
  imageUrl?: string;
  pageLink?: string;
}
@Component({
  selector: 'app-social',
  templateUrl: './social.component.html',
  styleUrls: ['./social.component.scss']
})
export class SocialComponent implements OnInit {
  @Input() config: SocialCtrlInterface;
  constructor(public pageService:PageService ) { }

  facebookShareUrl: string = null;
  twitterShareUrl: string = null;
  pinterestShareUrl: string = null;

  private jwtBearerToken: string = null;
  bottomOffset:string = `0px`;
  
  ngOnInit() {

    if (this.pageService.diLayout.isFooterEnabled) {
      const defaultFooterHeight = 56;
      this.bottomOffset = `${Number.parseInt(this.pageService.diLayout.footer.footerHeight ||  defaultFooterHeight, 10)}px`;
    } 

    if (this.config.hasOwnProperty('pageLink') && this.config.pageLink != ''){
      //Do Nothing
    } else {
      this.config.pageLink    = window.location.href
    }

    let payload   = {
      "url": this.config.pageLink,
      "og:title": this.getTitle,
      "og:description": this.getDescription,
      "og:image": this.getImageUrl,
      "twitter:card": "summary"
    }

    let header = {
      "noTimestamp": true
    }

    this.bearerToken      = this.generateJwtBearerToken(header, payload);

    this.facebookShareUrl = this.getFacebookShareUrl
    
    this.pinterestShareUrl= this.getPinterestShareUrl

    this.twitterShareUrl  = this.getTwitterShareUrl
  }


  /**
   * Getter for product title
   * @return [title]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  get getTitle() {
    return this.config.title || "";
  }

  /**
   * Getter for product description
   * @return [description]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  get getDescription() {
    return this.config.description || "";
  }

  /**
   * Getter for product image
   * @return [imageUrl]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  get getImageUrl() {
    return this.config.imageUrl || "http://cdn.qliktag.com/qweb/image-not-found-v1.jpg";
  }

  /**
   * Method to generate jwt bearer token
   * @return [token: string]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   * @reference - https://github.com/kjur/jsrsasign/wiki/Tutorial-for-JWT-generation 
   *  https://kjur.github.io/jsjws/api/symbols/KJUR.jws.JWS.html#.sign
   */
  generateJwtBearerToken(header: any, payload: any) : string {
    return KJUR.jws.JWS.sign("HS256", JSON.stringify(header), JSON.stringify(payload), this.getJwtSignature)
  }

  /**
   * Setter for jwt token
   * @return [void]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  set bearerToken(token) {
    this.jwtBearerToken = token;
  }

  /**
   * Getter for bearer token
   * @return [token]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  get bearerToken() {
    return this.jwtBearerToken;
  }

  /**
   * Getter for jwt signature
   * @return [signature]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  get getJwtSignature() {
    return environment.jwt_signature
  }

  /**
   * Getter for facebook app id
   * @return [app_id]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  get getFacebookAppId() {
    return environment.facebookAppId
  }

  /**
   * Getter for facebook share url
   * @return [url]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  get getFacebookShareUrl() {
    return  `${environment.facebookShareUrl}?display=popup&app_id=${this.getFacebookAppId}&link=${environment.apiUrl}page/di/${this.bearerToken}`;
  }

  /**
   * Getter for pinterest share url
   * @return [url]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  get getPinterestShareUrl() {
    return  `${environment.pinterestShareUrl}?url=${environment.apiUrl}page/di/${this.bearerToken}&media=${this.getImageUrl}&description=${encodeURIComponent(this.getDescription)}`;
  }

  /**
   * Getter for twitter share url
   * @return [url]
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  get getTwitterShareUrl() {
    return    `${environment.twitterShareUrl}?text=${this.getTitle}&url=${environment.apiUrl}page/di/${this.bearerToken}`;
  }

}
